module.exports = __webpack_public_path__ + "static/media/editLogIcon.15950a05.svg";